import "@/src/shared/stylesheets/vuetify/_components.scss";
import "vuetify/styles";
import DayJsAdapter from "@date-io/dayjs";
import { aliases, easyIconSet } from "./easyIconset";
import { createVuetify, VuetifyOptions } from "vuetify";
import { vEasyTooltip } from "@/src/easy-ui/directives/easyTooltip";
import dayjs from "dayjs";

export const getVuetify = () => {
  const vuetifyConfig: VuetifyOptions = {
    theme: {
      defaultTheme: "easyTheme",
      themes: {
        easyTheme: {},
      },
    },
    icons: {
      defaultSet: "easyIconSet",
      aliases,
      sets: {
        easyIconSet,
      },
    },
    locale: {
      locale: window.EASY?.currentUser?.language,
      fallback: "en",
    },
    date: {
      adapter: new DayJsAdapter({ instance: dayjs }),
    },
    directives: { easyTooltip: vEasyTooltip },
  };

  return createVuetify(vuetifyConfig);
};
